import { Component, OnInit, Input } from '@angular/core';
import { TourService } from 'ngx-tour-md-menu';
@Component({
  selector: 'app-tour-guide',
  templateUrl: './tour-guide.component.html',
  styleUrls: ['./tour-guide.component.scss']
})
export class TourGuideComponent implements OnInit {
  @Input() data:any
  constructor(public tourService: TourService) { 
  }

  ngOnInit(): void {
  }

}
